import React from "react";
import { PageHero, Section } from "./_shared";
import { useMitcidco } from "./MitcidcoLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBody() {
  const data = useMitcidco();
  const list = data?.executive_body || [];
  return (
    <div data-testid="mitcidco-executive-body">
      <PageHero
        eyebrow="About"
        title="Executive Body Members"
        sub="The Executive Body of Gramaudyogik Shikshan Mandal — providing strategic direction and governance across all member institutions."
      />
      <Section>
        <BodyMembersTable members={list} theme="amber" testidPrefix="mitcidco-eb" />
      </Section>
    </div>
  );
}
